import React, { memo, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import QRCode from 'qrcode.react';
import styles from './PhoneQRcode.module.less';
import { logging } from '../../actions/log';
import { setPhoneVisible } from '../../actions/layout';
import { STORE_3G_HOST, STORE_3G_CHANNEL } from '../../config';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {}, [dispatch, logInfoData, logging]);

  const handleShowCloseQRcode = useCallback(
    (flag, ev) => {
      // 点击 关于 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Phone',
          label: '',
          param2: {
            source: 'HomePage',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      ev.stopPropagation();
      dispatch(setPhoneVisible(false));
    },
    [dispatch, logInfoData],
  );

  return (
    <div className={styles.QRcode_bg}>
      <div className={styles.QRcode} onClick={ev => handleShowCloseQRcode(false, ev)}>
        <a className={styles.QRcode_close} onClick={ev => handleShowCloseQRcode(false, ev)}>
          <i className="iconfont icon-close" />
        </a>
        <div className={styles.QRCode_code}>
          <QRCode
            className="qrcode-image"
            size={144}
            level="Q"
            value={`${STORE_3G_HOST}/redsea/com.lenovo.leos.appstore?ch=${STORE_3G_CHANNEL}`}
          />
        </div>
        <div className={styles.QRCode_info_desc}>想在手机端继续玩</div>
        <div className={styles.QRCode_info}>扫码下载联想应用商店手机版</div>
      </div>
    </div>
  );
});
